const pageChildren = {
    saveSuccess(key) {
        // 子页面操作成功
        if (key) {
            this[key] = true;
        }
    },
    getSuccess(key) {
        if (this[key]) {
            // this[key] = false;
            delete this[key];
            return true;
        }
        else {
            return false;
        }
    },
};
export default pageChildren;
